import styled from "@emotion/styled"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { useState } from "react"
import colors from "theme/colors"
import { Desktop, Mobile } from "ui"
import TabPanel from "ui/TabPanel"
import { extractProperty } from "utils"

import PersonItem from "./PersonItem"
import PersonSwiper from "./PersonSwiper"

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid rgba(130, 136, 148, 0.7);
  .MuiTab-root {
    color: ${colors.black};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    padding-bottom: 0px;
    border-bottom: 6px solid transparent;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 20px;
    }
  }
  .Mui-selected {
    border-bottom: 6px solid;
    color: ${colors.black};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 20px;
    }
  }
`

const StyledPersonList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 40px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 33px;
    gap: 26px;
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    gap: 40px;
    padding-top: 50px;
  }
`

const StyledBox = styled(Box)`
  padding-top: 24px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-top: 60px;
  }
`

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

export default function ColorTabs({
  data,
  locale,
}: {
  data: any
  locale: string
}) {
  const blocks = data.properties.find(
    (prop: any) => prop.propertyName === "teamsBlock",
  )?.propertyValue?.blocks
  const [value, setValue] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <StyledBox sx={{ width: "100%" }}>
      <StyledTabs
        value={value}
        onChange={handleChange}
        aria-label="כרטיסיות אנשים"
      >
        {blocks.map((block: any, index: number) => (
          <Tab
            key={index.toString()}
            label={extractProperty(block, "teamTitle")}
            {...a11yProps(index)}
          />
        ))}
      </StyledTabs>
      {blocks.map((block: any, index: number) => (
        <TabPanel key={index.toString()} value={value} index={index} idPrefix="full-width">
          <Desktop>
            <StyledPersonList>
              {block.properties
                .find((prop: any) => prop.propertyName === "teamInnerList")
                ?.propertyValue?.blocks?.map((person: any, ind: number) => {
                  const name = extractProperty(person, "teamName")
                  const role = extractProperty(person, "teamRole")
                  const description = extractProperty(person, "teamDescription")

                  const image = extractProperty(person, "teamImage")

                  const isYellow = extractProperty(
                    block,
                    "changingColorToYellow",
                  )
                  return (
                    <PersonItem
                      localeLang={locale}
                      noHover={isYellow}
                      key={ind.toString()}
                      image={image}
                      title={name}
                      role={role}
                      description={description}
                      color={colors.white}
                      isYellow={isYellow}
                    />
                  )
                })}
            </StyledPersonList>
          </Desktop>
          <Mobile>
            <PersonSwiper
              data={extractProperty(block, "teamInnerList")}
              isYellow={extractProperty(block, "changingColorToYellow")}
            />
          </Mobile>
        </TabPanel>
      ))}
    </StyledBox>
  )
}
